import React from "react"
import Layout from "../../components/layout"
import Seo from "../../components/seo"
import { Link, graphql } from 'gatsby'
import ArticleArea from "../../components/note/article-area"
import NoteLists from "../../components/note/note-lists"
import { colorCode } from "../../functions/middle-category-style"
import LazyAndPreloadImage from "../../functions/lazy_and_preload_image"
import RelatedComponents from "../../components/related-components"
import { convertTimeToAziaZone } from "../../functions/convert-time-to-azia-timezone"
import "../../styles/pc/page/note/note_id.scss"
import "../../styles/sp/page/note/note_id.scss"

export default function CaseStudyPost({ data }) {
  const info = data.microcmsNotes
  return (
    <Layout isNote={true}>
      <Seo
        type="article"
        title="ジェイフィールのオウンドメディア イキイキ・ワクワク事例集詳細"
        description=""
        bobyClassName="menu27"
      />
      <div className="wrapper">
        <div className="wrapper_contents">
          <div className="path fixed pc_only">
            <div className="left_navi"><span className="vertical"><Link to="/">Home</Link>　/　<Link to="/note">J.Feel Note</Link>　/　<Link to={`/note/` + info.notesId }  className="current">{ info.title }</Link></span></div>
          </div>{/* left_navi */}
          <div className="main">
        {/*//////////////////////////////* ↓コンテンツ01 * //////////////////////////////*/}
        <div className="contents_01 detail">
          <div className="contents_in">
            <div className="padding_sp">{/* スマホのみ隙間 */}
              <div className="wrap_box w670">
                <div className="category_title">
                  { info.middle_category ?
                    <Link to={'/note/category/' + info.middle_category.name}>
                      <span className="single case_study" style={{background: colorCode(info.middle_category.display_color ? info.middle_category.display_color[0] : '')}}>
                        {info.middle_category.name}
                      </span>
                    </Link>
                    : ''
                  }
                </div>
                <div className="note_id_img"><LazyAndPreloadImage imgUrl={info.top_image ? info.top_image.url : ''} alt="top画像" /></div>
                <div className="note_id_title">{info.title}</div>
                <div className="note_id_subtitle">{info.subtitle}</div>
                <div className="day_wrap">
                  { info.contributor ?
                    <>
                    <LazyAndPreloadImage imgUrl={info.contributor.list_face_image ? info.contributor.list_face_image.url : ''} alt="事例集詳細" />
                    <p>
                      <span className="day_detail">{info.contributor.name}</span>
                      <span className="day">{convertTimeToAziaZone(info.date, "YYYY.MM.DD")}</span>
                    </p>
                    </>
                    :
                    <>
                    <LazyAndPreloadImage imgUrl={"/images/note/icon.png"} alt="事例集詳細" />
                    <p>
                      <span className="day_detail">ジェイフィール</span>
                      <span className="day">{convertTimeToAziaZone(info.date, "YYYY.MM.DD")}</span>
                    </p>
                    </>
                  }
                </div>
                <div className="m_btm56_pc m_btm41_sp">
                  <div dangerouslySetInnerHTML={{ __html: info.body}} />
                </div>
                { info.download_url_title ?
                  <>
                  <div className="bnr_box">
                    <Link to={info.download_file_url ? info.download_file_url.url : ''}><span>{info.download_url_title}</span></Link>
                  </div>
                  </>
                  : ''
                }
                { info.download_url_title_2 ?
                    <>
                      <div className="bnr_box">
                        <Link to={info.download_file_url_2 ? info.download_file_url_2.url : ''}><span>{info.download_url_title_2}</span></Link>
                      </div>
                    </>
                    : ''
                }
                { info.download_url_title_3 ?
                    <>
                      <div className="bnr_box">
                        <Link to={info.download_file_url_3 ? info.download_file_url_3.url : ''}><span>{info.download_url_title_3}</span></Link>
                      </div>
                    </>
                    : ''
                }
                <div className="note_tag" style={{marginTop: '0px'}}>
                  {info.tags.map((tag) => (
                    tag.type[0] === "ノートタグ" ? <Link key={tag.id} to={'/note/tag/' + tag.name}>#{tag.name}</Link> : ''
                  ))}
                </div>

                <RelatedComponents
                  relatedPrograms={info.related_programs}
                  relatedSeminars={info.related_seminars}
                  relatedBooks={info.related_books}
                  relatedArticles={info.related_articles}
                />

              </div>
            </div>{/* padding_sp スマホのみ隙間 */}
          </div>{/* contents_in */}
        </div>{/* /contents */}

        <ArticleArea />

        {/*//////////////////////////////* ↑コンテンツ01 * //////////////////////////////*/}
        {/*//////////////////////////////* ↓コンテンツ02 * //////////////////////////////*/}
        {/* 
        { data.caseStudies ?
          <NoteLists needOverWrite={true} overWriteData={data.caseStudies.edges} overWriteType={"caseStudy"} />
          : ''
        } */}

        {/*//////////////////////////////* ↑コンテンツ02 * //////////////////////////////*/}
          </div>{/* main */}
          <div className="page_title fixed">
            <div className="right_page_ttl"><span className="vertical">J.Feel Note - </span><span className="txt">ジェイフィールのオウンドメディア</span></div>
          </div>{/* right page_title */}
        </div>{/*wrapper_contents*/}
      </div>{/*wrapper*/}
    </Layout>
  )
}

export const query = graphql`
query CaseStudyIdQuery($id: String!) {
  microcmsNotes(notesId: {eq: $id}) {
    notesId
    title
    subtitle
    contributor {
      name
      list_face_image {
        url
      }
    }
    top_image {
      url
    }
    date:publishedAt
    body
    download_url_title
    download_file_url {
      url
    }
    download_url_title_2
    download_file_url_2 {
      url
    }
    download_url_title_3
    download_file_url_3 {
      url
    }
    middle_category {
      id
      name
      display_color
    }
    tags {
      id
      name
      type
    }
    related_books {
      id
      title
      display_image {
        url
      }
    }
    related_articles {
      id
      thumbnail {
        url
      }
      title
      middle_category {
        id
        name
        display_color
      }
      tags {
        id
        name
        type
      }
    }
    related_programs {
      id
      thumbnail {
        url
      }
      title
      subtitle
      task_tags {
        id
        name
        type
      }
      hierarchy_tags {
        id
        name
        type
      }
    }
    related_seminars {
      id
      image {
        url
      }
      status
      title
      display_event_date
      tags {
        id
        name
        type
      }
      types
    }
  }

  caseStudies: allMicrocmsNotes(
    limit: 3
    sort: {fields: [publishedAt], order: DESC}
    filter: {notesId: {ne: $id}, large_category: {eq: "事例集"}}
  ) {
    edges {
      node {
        notesId
        title
        large_category
        middle_category {
          id
          name
          display_color
        }
        thumbnail {
          url
        }
        tags {
          id
          name
          type
        }
      }
    }
  }
}`
